// extracted by mini-css-extract-plugin
module.exports = {"actionbar":"ProductListWrapper_actionbar__3y6gG","searchbar":"ProductListWrapper_searchbar__ELL3a"};